import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Kuzey Yapı Hırdavat";
const SITE_URL = "https://www.kuzeyyapi.tr";
const DEFAULT_DESC = "Profesyoneller için kaliteli hırdavat, inşaat ve el aletleri. 1916+ orijinal SGS ürünü, bayi sistemi, hızlı kargo ile Çaycuma / Zonguldak'tan tüm Türkiye'ye.";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_kuzey-b2b-hub/artifacts/ngl4j0hv_kuzey%20%20yap%C4%B1%20logo.jpg";

export default function Seo({ title, description, image, path = "", noIndex = false, schema = null }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — B2B Hırdavat & İnşaat Mağazası`;
  const desc = description || DEFAULT_DESC;
  const img = image ? (image.startsWith("/") ? window.location.origin + image : image) : DEFAULT_IMAGE;
  const url = SITE_URL + path;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc}/>
      <link rel="canonical" href={url}/>
      {noIndex && <meta name="robots" content="noindex,nofollow"/>}

      {/* Open Graph */}
      <meta property="og:type" content="website"/>
      <meta property="og:site_name" content={SITE_NAME}/>
      <meta property="og:title" content={fullTitle}/>
      <meta property="og:description" content={desc}/>
      <meta property="og:image" content={img}/>
      <meta property="og:url" content={url}/>
      <meta property="og:locale" content="tr_TR"/>

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={fullTitle}/>
      <meta name="twitter:description" content={desc}/>
      <meta name="twitter:image" content={img}/>

      {/* Structured data */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

// LocalBusiness/Organization schema for the brand
export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "HardwareStore",
  "name": SITE_NAME,
  "image": DEFAULT_IMAGE,
  "url": SITE_URL,
  "telephone": "+90 553 942 67 89",
  "email": "admin@kuzeyyapi.tr",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Yeni Mahalle, Oktay-Olcay Yurtbay Caddesi No:28/A",
    "addressLocality": "Çaycuma",
    "addressRegion": "Zonguldak",
    "addressCountry": "TR",
  },
  "openingHours": "Mo-Sa 08:30-18:30",
  "priceRange": "₺₺",
};

export function productSchema(p) {
  if (!p) return null;
  const price = p.pricing?.gross_price ?? 0;
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": p.name,
    "sku": p.sku,
    "brand": { "@type": "Brand", "name": p.brand || "SGS" },
    "image": p.image_url?.startsWith("/") ? window.location.origin + p.image_url : p.image_url,
    "description": p.description,
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": "TRY",
      "availability": (p.stock || 0) > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "url": SITE_URL + "/urun/" + p.slug,
    },
  };
}
